import React, { useEffect } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ReportsListing from "./ReportsListing";

const Reports = () => {
  const breadcrumbItems = [
    { title: "Reports", link: "" },
    { title: "Reports", link: "/reports/reports" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card className="card_container">
            <ReportsListing />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Reports;
